// extracted by mini-css-extract-plugin
module.exports = {"burger":"burger_burger__LoMOq"};